import Swal from 'sweetalert2/dist/sweetalert2.js';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { ApiResponseModel } from '../entities/api-response.model';
import {Observable, throwError} from 'rxjs';
import {HttpRequestOptionsModel} from '../entities/http-request-options.model';
import {catchError, finalize, map, tap} from 'rxjs/operators';
import {ok} from 'assert';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class HttpApiService {

    public apiURL = 'https://getjobs.bestwebsolutions.ro/api/';

    constructor( private http: HttpClient, private router: Router ) {

    }

    private handleError(exception): void {
        console.log(exception);

        if (exception.error && exception.error.message === 'auth.login.fail') {
            Swal.fire('Autentificare', 'Adresa de email sau parola nu este corecta. Va rugam sa incercati din nou.', 'error');
        }

        if (exception.status === 0) {
            Swal.fire('Eroare', 'Nu s-a putut realiza conexiunea cu serverul. Va rugam sa incercati din nou.', 'error');
        }

        if (exception.status === 511) {
            Swal.fire('Autentificare', 'Sesiunea dumneavoastra a expirat, va rugam sa va reautentificati!', 'error');
            localStorage.removeItem('auth-token');
            this.router.navigateByUrl('/auth/login');
        }

    }

    public getAuthToken(): string {
        return 'Bearer ' + localStorage.getItem('auth-token');
    }

    public getHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.getAuthToken(),
        });
    }

    public getUrl(path: string): string {
        return this.apiURL + path;
    }

    public setParameters(data: any): any {

        const result = [];

        if(!data){
            return result;
        }

        const _this = this;

        Object.keys(data).map(function(key) {

            if( typeof data[key] === 'object' ){
                result[key] = _this.setParameters(data[key]);
            }else{
                result[key] = (data[key]) ? data[key] : '';
            }
        });

        return result;
    }

    public httpGet(path: string, params?: any): Observable<any> {

        const url = this.getUrl(path);
        const httpOptions = new HttpRequestOptionsModel();

        httpOptions.headers = this.getHeaders();
        httpOptions.params = this.setParameters(params);


        return this.http.get(url, httpOptions)
            .pipe(
                tap(response => {
                    // For errors with http code 200
                    // @ts-ignore
                    if (response.status === false) {
                        // @ts-ignore
                        Swal.fire('Eroare', response.message, 'error');
                    }

                }),
                catchError((err) => {
                    this.handleError(err);
                    return throwError(err);
                }),
                finalize(() => {

                })
            );
    }

    public httpPost(path: string, body?: any): Observable<any> {

        const url = this.getUrl(path);
        const httpOptions = new HttpRequestOptionsModel();
        httpOptions.headers = this.getHeaders();

        return this.http.post(url, body, httpOptions)
            .pipe(
                tap(
                    response => {
                        // For errors with http code 200
                        // @ts-ignore
                        if (response.status === false) {
                            // @ts-ignore
                            Swal.fire('Eroare', response.message, 'error');
                        }

                    }
                ),
                catchError((err) => {
                    this.handleError(err);
                    return throwError(err);
                }),

                finalize(() => {

                })
            );

    }

    public httpPut(path: string, body?: any): Observable<any> {

        const url = this.getUrl(path);
        const httpOptions = new HttpRequestOptionsModel();
        httpOptions.headers = this.getHeaders();

        return this.http.put(url, body, httpOptions)
            .pipe(
                tap(
                    response => {
                        // For errors with http code 200
                        // @ts-ignore
                        if (response.status === false) {
                            // @ts-ignore
                            Swal.fire('Eroare', response.message, 'error');
                        }

                    }
                ),
                catchError((err) => {
                    this.handleError(err);
                    return throwError(err);
                }),

                finalize(() => {

                })
            );

    }

    public httpDelete(path: string, body?: any): Observable<any> {

        const url = this.getUrl(path);
        const httpOptions = new HttpRequestOptionsModel();
        httpOptions.headers = this.getHeaders();
        httpOptions.params = this.setParameters(body);

        return this.http.delete(url, httpOptions)
            .pipe(
                tap(
                    response => {
                        // For errors with http code 200
                        // @ts-ignore
                        if (response.status === false) {
                            // @ts-ignore
                            Swal.fire('Eroare', response.message, 'error');
                        }

                    }
                ),
                catchError((err) => {
                    this.handleError(err);
                    return throwError(err);
                }),

                finalize(() => {

                })
            );

    }

    public postFile(file: File, entity: string, type: string, uid: string): Observable<any>
    {
        const formData = new FormData();

        formData.append('file', file);
        formData.append('type', type);
        formData.append('entity', entity);
        formData.append('uid', uid);

        return this.http.post<any>(this.getUrl('postFiles'), formData)
            .pipe(
                tap(
                    response => {
                        // For errors with http code 200
                        // @ts-ignore
                        if (response.status === false) {
                            // @ts-ignore
                            Swal.fire('Eroare', response.message, 'error');
                        }

                    }
                ),
                catchError((err) => {
                    this.handleError(err);
                    return throwError(err);
                }),

                finalize(() => {

                })
            );
    }

    public getFile(entity: string, type: string, uid: string, allFiles: boolean = true): Observable<any>
    {
        const formData = new FormData();

        formData.append('type', type);
        formData.append('entity', entity);
        formData.append('uid', uid);
        // @ts-ignore
        formData.append('allFiles', allFiles.toString());

        return this.http.post<any>(this.getUrl('getFile'), formData)
            .pipe(
                tap(
                    response => {
                        // For errors with http code 200
                        // @ts-ignore
                        if (response.status === false) {
                            // @ts-ignore
                            Swal.fire('Eroare', response.message, 'error');
                        }

                    }
                ),
                catchError((err) => {
                    this.handleError(err);
                    return throwError(err);
                }),

                finalize(() => {

                })
            );
    }
}
